export const FAILED = 'user/failed';
export const LOADING = 'user/loading';
export const SUCCESS = 'user/success';
export const SET_DATA = 'user/set_data';
export const CLEAR_MESSAGE = 'user/clear_message';
export const DOWNLOAD_FAILED = 'user/download/failed';
export const DOWNLOAD_LOADING = 'user/download/loagding';
export const DOWNLOAD_SUCESS = 'user/download/successs';
